export const updateContext = (e, contextState, meta = null) => {
    const name = e?.target?.name ?? meta?.name;
    const value = e?.target?.value ?? e?.value;
    let text = meta?.text
    let id = meta?.id;

    if (e?.target?.options?.length) {
        text = e.target?.options[e.target.selectedIndex]?.dataset?.description;
        id = e.target?.options[e.target.selectedIndex]?.dataset?.id;
    }

    return {
        ...contextState,
        selectedBenefits: {
            ...contextState.selectedBenefits,
            [name]: value,
        },
        selectedBenefitsNames: {
            ...contextState.selectedBenefitsNames,
            [name]: text,
        },
        selectedBenefitsIds: {
            ...contextState.selectedBenefitsIds,
            [name]: id,
        },
    }
}

export const updateDependantsContext = (action, contextState, id = null) => {
    let updatedDependants;

    switch (action) {
        case 'ADD':
            updatedDependants = [...contextState.dependants, contextState.dependantData];
            break;
        case 'UPDATE':
            updatedDependants = contextState.dependants.map((dependant) =>
                dependant.id === contextState.dependantData.id
                    ? { ...dependant, ...contextState.dependantData }
                    : dependant
            )
            break;
        case 'REMOVE':
            updatedDependants = contextState.dependants.filter(
                (dependant) => dependant.id !== id
            )
            break

        default:
            throw new Error(`Acción no reconocida: ${action}`);
    }

    return {
        ...contextState,
        dependants: updatedDependants,
    }
}